module.exports = __webpack_public_path__ + "media/images/icons/icons_small/60_flowerboquet-cc933d6f5d37e61b9a337e27bf305a90.png";